<template>
  <div class="container-fluid">

    <!-- 精選作品展示 -->
    <section class="featured-works py-5 bg-light">
      <div class="container">

        <!-- 加密貨幣套利工具 -->
        <div class="row align-items-center mb-5">
          <div class="col-md-6">
            <h3>{{ $t('FundingRate.title') }}</h3>
            <p class="lead">{{ $t('FundingRate.subtitle') }}</p>
            <div class="d-flex align-items-center justify-content-center">
              <ul class="list-unstyled text-start">
                <li><i class="bi bi-check-circle-fill text-success"></i> {{ $t('FundingRate.feature1') }}</li>
                <li><i class="bi bi-check-circle-fill text-success"></i> {{ $t('FundingRate.feature2') }}</li>
                <li><i class="bi bi-check-circle-fill text-success"></i> {{ $t('FundingRate.feature3') }}</li>
                <li><i class="bi bi-check-circle-fill text-success"></i> {{ $t('FundingRate.feature4') }}</li>
              </ul>
            </div>
            <a href="https://elcodingstudio.github.io/arbitrage-bot/" class="btn btn-primary mb-3" target="_blank">{{ $t('FundingRate.btn') }}</a>
          </div>
          <div class="col-md-6">
            <img src="../assets/images/project-banner/arbitrage-snapshot.jpg" class="img-fluid rounded shadow bg-light" alt="加密貨幣套利系統截圖">
          </div>
        </div>

        <!-- Mobile App 開發 -->
        <div class="row align-items-center mb-5 flex-md-row-reverse">
          <div class="col-md-6">
            <h3>{{ $t('MobileApp.title') }}</h3>
            <p class="lead">{{ $t('MobileApp.subtitle') }}</p>
            <div class="d-flex align-items-center justify-content-center">
              <ul class="list-unstyled text-start">
                <li><i class="bi bi-check-circle-fill text-success"></i> {{ $t('MobileApp.feature1') }}</li>
                <li><i class="bi bi-check-circle-fill text-success"></i> {{ $t('MobileApp.feature2') }}</li>
                <li><i class="bi bi-check-circle-fill text-success"></i> {{ $t('MobileApp.feature3') }}</li>
                <li><i class="bi bi-check-circle-fill text-success"></i> {{ $t('MobileApp.feature4') }}</li>
              </ul>
            </div>
            <a href="#" class="btn btn-primary mb-3" data-bs-toggle="modal" data-bs-target="#mobileAppModal">{{ $t('MobileApp.btn') }}</a>
          </div>
          <div class="col-md-6">
            <img src="../assets/images/project-banner/app-dev.jpg" class="img-fluid rounded shadow" alt="Mobile App 開發">
          </div>
        </div>

        <!-- 網路爬蟲專案 -->
        <div class="row align-items-center">
          <div class="col-md-6">
            <h3>{{ $t('Webscrapping.title') }}</h3>
            <p class="lead">{{ $t('Webscrapping.subtitle') }}</p>
            <div class="d-flex align-items-center justify-content-center">
              <ul class="list-unstyled text-start">
                <li><i class="bi bi-check-circle-fill text-success"></i> {{ $t('Webscrapping.feature1') }}</li>
                <li><i class="bi bi-check-circle-fill text-success"></i> {{ $t('Webscrapping.feature2') }}</li>
                <li><i class="bi bi-check-circle-fill text-success"></i> {{ $t('Webscrapping.feature3') }}</li>
              </ul>
            </div>
            <a href="#" class="btn btn-primary mb-3" data-bs-toggle="modal" data-bs-target="#scrapingModal">{{ $t('Webscrapping.btn') }}</a>
          </div>

          <div class="col-md-6">
            <img src="../assets/images/project-banner/web-scraping.jpg" class="img-fluid bg-secondary rounded shadow" alt="資料擷取系統展示">
          </div>
        </div>
      </div>
    </section>

    <!-- 其他服務 -->
    <section class="other-services py-5">
      <div class="container">
        <h2 class="text-center mb-5">{{ $t('BusinessOptimization.main-title') }}</h2>
        <div class="row g-4">
          <div class="col-md-6">
            <div class="card h-100">
              <div class="card-body">
                <h5 class="card-title">{{ $t('BusinessOptimization.excel.title') }}</h5>
                <p class="card-text">{{ $t('BusinessOptimization.excel.description') }}</p>
                <div class="d-flex align-items-center justify-content-center">
                  <ul class="list-unstyled text-start">
                    <li><i class="bi bi-arrow-right"></i> {{ $t('BusinessOptimization.excel.feature1') }}</li>
                    <li><i class="bi bi-arrow-right"></i> {{ $t('BusinessOptimization.excel.feature2') }}</li>
                    <li><i class="bi bi-arrow-right"></i> {{ $t('BusinessOptimization.excel.feature3') }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card h-100">
              <div class="card-body">
                <h5 class="card-title">{{ $t('BusinessOptimization.document.title') }}</h5>
                <p class="card-text">{{ $t('BusinessOptimization.document.description') }}</p>
                <div class="d-flex align-items-center justify-content-center">
                  <ul class="list-unstyled text-start">
                    <li><i class="bi bi-arrow-right"></i> {{ $t('BusinessOptimization.document.feature1') }}</li>
                    <li><i class="bi bi-arrow-right"></i> {{ $t('BusinessOptimization.document.feature2') }}</li>
                    <li><i class="bi bi-arrow-right"></i> {{ $t('BusinessOptimization.document.feature3') }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <MobileApp></MobileApp>
  <WebScrapping></WebScrapping>
</template>

<script>
import MobileApp from './Modal/MobileApp.vue';
import WebScrapping from './Modal/WebScrapping.vue';

export default {
  components: {
    MobileApp,
    WebScrapping
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>
<style>
.card-img-top {
  object-fit: cover;
  width: 100%;
  height: 200px;
  /* 設置您期望的圖片高度 */
}

.project-title-with-image {
  background-image: url('../assets/images/service-title.png');
  height: 55px;
  width: 296px;
  padding-top: 2px;
}

.carousel-item {
  max-width: 1000px;
}
</style>